import { useTranslation } from "react-i18next";
import Button from "../../../components/ui/Button";
import styles from "../css/LearnigHistoryScreen.module.css";
import LearningHistory from "../model/LearningHistory";
import { LearningHistoryRange } from "../model/learningHistoryRange";
import LearningHistoryCell from "./LearningHistoryCell";
import LearningRetry from "../model/LearningRetry";
import { useState } from "react";
import LearningReview from "./LearningReview";

interface LearningHistoryScreenProps {
  items: LearningHistory[];
  onClickItem: (item: LearningHistory) => void;
  onStartReview: (item: LearningRetry) => void;
}

export default function LearningHistoryScreen(
  props: LearningHistoryScreenProps
) {
  const { t } = useTranslation();

  const [openLearningReview, setOpenLearningReview] = useState<boolean>(false);

  function getRange(index: number): LearningHistoryRange {
    if (index === 0) {
      return LearningHistoryRange.day;
    } else if (index === 1) {
      return LearningHistoryRange.yesterday;
    } else if (index === 2) {
      return LearningHistoryRange.three_days;
    } else if (index === 3) {
      return LearningHistoryRange.week;
    } else if (index === 4) {
      return LearningHistoryRange.month;
    } else {
      return LearningHistoryRange.all;
    }
  }

  return (
    <>
      <div className={styles.screen}>
        <div className={styles.list}>
          {props.items.map((item, index) => (
            <LearningHistoryCell
              key={index}
              learningHistory={item}
              learningHistoryRange={getRange(index)}
              handleOnClick={props.onClickItem}
            />
          ))}
        </div>
        <Button
          size="lg"
          fullWidth
          className={styles.reviewButton}
          onClick={() => {
            setOpenLearningReview(true);
          }}
        >
          {t("LearningReviewButton")}
        </Button>
        <LearningReview
          open={openLearningReview}
          onClickStartButton={(learningRetry: LearningRetry) => {
            props.onStartReview(learningRetry);
          }}
          onClose={() => {
            setOpenLearningReview(false);
          }}
        />
      </div>
    </>
  );
}
